export default "__VITE_ASSET__BtCbF5t4__"